<div class="section-basic-head">
  <!-- mat-icon はこの位置 -->
  <ng-content select=".section-basic-head-icon"></ng-content>
  <!-- タイトル部分 -->
  <div class="section-basic-head-label"><ng-content></ng-content></div>
  <!-- 右肩領域 -->
  <ng-content select=".section-basic-head-util"></ng-content>
</div>
